
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CodeCoverageTableLoading',
  props: {
    isWidget: {
      type: Boolean,
      default: false
    },
    rowCount: {
      type: Number,
      default: 20
    }
  }
})
